import { StoreService } from "@common/data-access";
import { Constantes, RetailCompassStorage } from "@common/utils";
import { flatten, uniq } from "lodash";
import React from "react";
import { useEffectOnce } from "react-use";
import { MENU_TREE_ITEMS } from "./menu-tree-items";
import { filterMenuItems } from "./menu-validation-util";

export const useGetFilteredMenuItems = () => {
    const user = RetailCompassStorage.getUser();
    const stores = RetailCompassStorage.getTotalStores();
    const [productAcceses, setProductAccesses] = React.useState([]);
    const allowedApps = uniq(flatten(stores.map((s) => s.allowedApps)));

    useEffectOnce(() => {
        const ids = stores.map((store) => store.id);

        function parseProductAccess(productAcceses, allowedApps) {
            productAcceses.forEach((app) => {
                app.enabled = allowedApps.includes(app.internalName);
                app.active = app.internalName === Constantes.APP_NAME;
            });
        }

        const getProductAccesses = async () => {
            const result = await StoreService.getAvailableApps(ids);
            parseProductAccess(result, allowedApps);
            setProductAccesses(result);
        };

        getProductAccesses();
    });

    const validationContext = React.useMemo(
        () => ({
            allowedApps: allowedApps,
            user,
        }),
        [allowedApps, user]
    );

    const filteredMenuItems = React.useMemo(() => {
        return filterMenuItems(
            MENU_TREE_ITEMS,
            validationContext,
            productAcceses
        );
    }, [productAcceses, validationContext]);

    return { filteredMenuItems };
};
